import {
  GlobalOutlined,
  InstagramOutlined,
  LinkedinOutlined,
  TikTokOutlined,
  TwitterOutlined,
  YoutubeOutlined,
} from "@ant-design/icons";
import { SocialMediaPlatform } from "../types/influencer";

export function getPlatformIcon(platform: string, className?: string) {
  const normalizedPlatform = platform?.toLowerCase() ?? "";

  switch (normalizedPlatform) {
    case SocialMediaPlatform.Instagram:
      return <InstagramOutlined className={className} />;
    case SocialMediaPlatform.YouTube:
    case "youtube":
      return <YoutubeOutlined className={className} />;
    case SocialMediaPlatform.LinkedIn:
    case "linkedin":
      return <LinkedinOutlined className={className} />;
    case SocialMediaPlatform.TikTok:
    case "tiktok":
      return <TikTokOutlined className={className} />;
    case "twitter":
    case "x":
      return <TwitterOutlined className={className} />;
    default:
      return <GlobalOutlined className={className} />;
  }
}
